/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// ICON STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
  FAIcon: {
    '& > svg': {
      height: '100%',
      width: 'auto',
      display: 'block'
    },
  }
};
